import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["content", "submit"]

  submit(event) {
    event.preventDefault()
    if (this.submitting) return

    const form = event.currentTarget
    const formData = new FormData(form)
    const submit = this.hasSubmitTarget ? this.submitTarget : null
    const submitLabel = submit ? submit.value : null
    this.submitting = true

    if (submit) {
      submit.disabled = true
      submit.value = "Saglabā..."
    }

    fetch(form.action, {
      method: form.method,
      body: formData,
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": this.csrfToken()
      },
      credentials: "same-origin"
    })
      .then((response) => response.json())
      .then((data) => {
        this.contentTarget.innerHTML = data.html
      })
      .catch(() => {
        this.showSubmitError()
      })
      .finally(() => {
        this.submitting = false

        if (submit && document.body.contains(submit)) {
          submit.disabled = false
          submit.value = submitLabel
        }
      })
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta && meta.content
  }

  showSubmitError() {
    this.contentTarget.querySelectorAll(".survey-form-submit-error").forEach((alert) => alert.remove())
    this.contentTarget.insertAdjacentHTML(
      "afterbegin",
      "<div class=\"alert alert-danger survey-form-submit-error\">Neizdevās saglabāt aptaujas atbildes. Lūdzu, mēģiniet vēlreiz.</div>"
    )
  }
}
